export default __webpack_public_path__ + "static/media/granny-crush.c84509ff.gif";